/**
 * La normalisation des énoncés vit dans le design system, à côté de `<RichText>` qui la rend
 * (`design-system/molecules/RichText/enonceLatex.ts`) : le design system ne lit pas `src/common`.
 * Ce ré-export garde le chemin des lecteurs legacy (MarkdownWithLatex.web.js et son test).
 */
export {
    normalizeEnonceLatex,
    remarkEnonceLatex,
    repairFormula,
} from "../../design-system/molecules/RichText/enonceLatex"
